import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.amaxPayment.SuccessPage', {
    title: 'Amax Payment | Success',
    paymentConfirmed: 'Payment confirmed',
    paymentConfirmedDescription: 'Payment is confirmed via the banking app.',
    youWillBeRedirected: 'You will be automatically redirected to the payment summary in a few seconds.',
    learnMore: 'Learn more',
    paymentSummary: 'Payment summary',
});
